import {event} from "./selection/on";

export default function() {
  var current = event, source;
  while (source = current.sourceEvent) current = source;
  return current;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-selection/src/sourceEvent.js
// module id = EFcH
// module chunks = 0